import { effect, Injectable, signal } from "@angular/core";
import { CURSOR } from "../interfaces/cursor.interface";

@Injectable({
  providedIn: 'root'
})
export class CursorService {
  private _cursor = signal<CURSOR>(CURSOR.DEFAULT);

  public readonly cursor = this._cursor.asReadonly();

  constructor() {
    effect(() => {
        const value = this._cursor();

        if (!document?.body) return;

        if (value === CURSOR.DEFAULT) {
            document.body.style.removeProperty('cursor');
            return;
        }

        document.body.style.setProperty('cursor', value, 'important');
    });
  }

  setCursor(cursor: CURSOR): void {
    this._cursor.set(cursor);
  }

  setToDefault(): void {
    this._cursor.set(CURSOR.DEFAULT);
  }
}